import { IFeccPosition } from '@/shared/interfaces/fecc-position/fecc-position.interface';
import { createAction, props } from '@ngrx/store';
const SELECT_FECC_DEVICE = 'SELECT_FECC_DEVICE';

export const selectFeccDevice = createAction(
    SELECT_FECC_DEVICE,
    props<{ codec: string; feccConfig: IFeccPosition }>()
);
